[
  {
    "code": "TV-FUN",
    "name": "Funafuti"
  },
  {
    "code": "TV-NMG",
    "name": "Nanumanga"
  },
  {
    "code": "TV-NMA",
    "name": "Nanumea"
  },
  {
    "code": "TV-NIT",
    "name": "Niutao"
  },
  {
    "code": "TV-NIU",
    "name": "Nui"
  },
  {
    "code": "TV-NKF",
    "name": "Nukufetau"
  },
  {
    "code": "TV-NKL",
    "name": "Nukulaelae"
  },
  {
    "code": "TV-VAI",
    "name": "Vaitupu"
  }
]